module.exports = __webpack_public_path__ + "img/1-1-p3.994e1c70.svg";